export const isScriptLoadedById = id => {
  return !!document.getElementById(id)
}
